(function(){
    'use strict';

    var $smpLangSwitch = $('.smp-lang-switch');

    if($smpLangSwitch.length){
        $smpLangSwitch.find('button').on('click', function(){
            setCookie('language', $(this).attr('data-language'), 30);
            $smpLangSwitch.find('button').removeClass('active');
            updateLanguage($(this).attr('data-language'));
            $(this).addClass('active');
        });
    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function updateLanguage (language) {
        $('.megamenu__col--1 a').each(function(){
            if($(this).attr('data-' + language).length) {
                $(this).text($(this).attr('data-' + language));
            }
        });
    }
}());
